import React from 'react';
import Grid from 'material-ui/Grid';
import Button from 'material-ui/Button';
import { Link } from 'react-router-dom';

class result extends React.Component{

  render(){
    return (
      <div className="center-container">
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <div className="contents-title-cont">
                <h1 className="contents-title">CONTACT</h1>
                <p className="contents-sub-title">お問い合わせありがとうございます</p>
              </div>
              <div className="contact-result main-cont">
                  <p className="form-comment">お問い合わせ頂いた内容は、担当者が確認のうえご連絡致します。<br />ご返信まで数日頂く場合がございますので、予めご了承ください</p>
                  <Link to="/">
                  <Button variant="raised" size="medium" style={{marginTop:20}} color="primary">
                    Home
                  </Button>
                  </Link>
                </div>
              
            </Grid>
          </Grid>
        </div>
    )
  }
}

export default result;


// WEBPACK FOOTER //
// ./src/component/contact/result.js